// Short team-radio squelch: a burst of band-passed noise and a two-tone chirp,
// played when the race engineer's message appears.

import { audioParams } from './params';

let noise: AudioBuffer | undefined;

export function radioBeep(ctx: AudioContext, important = false): void {
  const level = audioParams.master.value * 0.35;
  if (level <= 0 || ctx.state !== 'running') return;
  const t = ctx.currentTime;
  const out = ctx.createGain();
  out.gain.value = level;
  out.connect(ctx.destination);

  noise ??= (() => {
    const b = ctx.createBuffer(1, Math.floor(ctx.sampleRate * 0.12), ctx.sampleRate);
    const d = b.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
    return b;
  })();
  const src = ctx.createBufferSource();
  src.buffer = noise;
  const band = ctx.createBiquadFilter();
  band.type = 'bandpass';
  band.frequency.value = 1800;
  band.Q.value = 1.2;
  const ng = ctx.createGain();
  ng.gain.setValueAtTime(0.5, t);
  ng.gain.exponentialRampToValueAtTime(0.001, t + 0.1);
  src.connect(band).connect(ng).connect(out);
  src.start(t);

  const tones = important ? [1320, 1760] : [1175];
  tones.forEach((f, i) => {
    const o = ctx.createOscillator();
    o.type = 'sine';
    o.frequency.value = f;
    const g = ctx.createGain();
    const t0 = t + 0.06 + i * 0.09;
    g.gain.setValueAtTime(0, t0);
    g.gain.linearRampToValueAtTime(0.25, t0 + 0.01);
    g.gain.exponentialRampToValueAtTime(0.001, t0 + 0.08);
    o.connect(g).connect(out);
    o.start(t0);
    o.stop(t0 + 0.1);
  });
  setTimeout(() => out.disconnect(), 600);
}
